import { includes, some } from 'lodash';
import { extend } from "vee-validate";
import { required, email, min, max } from "vee-validate/dist/rules";

export default {
  mounted() {
    extend("required", {
      ...required,
      message: "{_field_} is required",
    });
    extend("min", {
      ...min,
      message: "{_field_} field must be at least {length} characters",
    });
    extend("max", {
      ...max,
      message: "{_field_} field may not be greater than {length} characters",
    });
    extend("email", {
      ...email,
      message: "{_field_} must be a valid email address",
    });
    extend("isUri", (value) => {
      if (/\w+:(\/?\/?)[^\s]+/.test(value)) {
        return true;
      }

      return "{_field_} must be a valid URI";
    });
    extend("isLanguage", (value) => {
      if (/[a-zA-Z]{1,8}(-[a-zA-Z0-9]{1,8})*/.test(value)) {
        return true;
      }

      return "{_field_} must be a valid language";
    });
    extend("password", {
      params: ["target"],
      validate(value, { target }) {
        return value === target;
      },
      message: "Password confirmation does not match",
    });
    extend("dimension", {
      validate: value => {
        if (/\d+\.\.\d+/.test(value)) {
          return true;
        }
      
        return "{_field_} must be a valid dimension (e.g 1..2)";
      }
    });
    extend("pouName", (value, [pouTempId]) => {
      if (some(this.$store.state.pous, pou => pou.name === value && pou.tempId !== pouTempId)) {
        return `${value} pou already exists`;
      }

      return true;
    });
    extend("resourceName", (value, [resourceTempId]) => {
      if (some(this.$store.state.configuration.resources, resource => resource.name === value && resource.tempId !== resourceTempId)) {
        return `${value} resource already exists`;
      }

      return true;
    });
    extend("dataTypeName", (value, [dataTypeTempId]) => {
      if (some(this.$store.state.dataTypes, dataType => dataType.name === value && dataType.tempId !== dataTypeTempId)) {
        return `${value} data type already exists`;
      }

      return true;
    });
    extend("uniqueName", (value, [existingNames]) => {
      const names = existingNames.split(';');
      if (includes(names, value)) {
        return `${value} already exists`;
      }

      return true;
    })
  },
};
